import { Component } from '@angular/core'
import { Store } from '@ngxs/store'
import { combineLatest, map } from 'rxjs'
import { WhatsNewEntry, entryDate } from 'src/app/domain/whats-new'
import { WhatsNewService } from 'src/app/services/whats-new.service'
import { UserState } from 'src/app/state-man/state/user.state'

/**
 * Hosted once in app.component.html. After an update, the first time the technician is signed in, a sheet lists
 * what changed in the versions this device has not seen (WhatsNewService.pending$). "Got it" acknowledges them.
 */
@Component({
  selector: 'rt-whats-new',
  template: `
    <div *ngIf="show$ | async as entries" class="rt-wn" role="dialog" aria-modal="true" aria-labelledby="rt-wn-title">
      <div class="rt-wn__scrim" (click)="whatsNew.dismiss()"></div>
      <div class="rt-wn__sheet">
        <div class="rt-wn__head">
          <img src="assets/brand/swirl.png" alt="" />
          <div>
            <span>RotoTrack updated</span>
            <b id="rt-wn-title">What's new in {{ entries[0].version }}</b>
          </div>
        </div>
        <div class="rt-wn__body">
          <section *ngFor="let e of entries; let first = first" class="rt-wn__entry">
            <h3 *ngIf="!first"><b>{{ e.version }}</b><span>{{ dateOf(e) }}</span></h3>
            <p *ngFor="let n of e.notes">{{ n }}</p>
          </section>
        </div>
        <div class="rt-wn__foot">
          <button type="button" class="rt-btn rt-btn--primary rt-btn--md" (click)="whatsNew.dismiss()">Got it</button>
        </div>
      </div>
    </div>`,
})
export class RtWhatsNewComponent {
  readonly show$ = combineLatest([this.whatsNew.pending$, this.store.select(UserState.getUser)]).pipe(
    map(([pending, user]) => (pending?.length && user?.is_logged_in ? pending : null)),
  )

  constructor(readonly whatsNew: WhatsNewService, private store: Store) {}

  dateOf(e: WhatsNewEntry): string {
    return entryDate(e.date)
  }
}
